export default function TripTravellerAllocationSegmentService(
    tripItemFlightRecommendationService
) {
    'ngInject';

    Object.assign(this, {
        getFlightSegmentAirportCodeRoute: (...args) => tripItemFlightRecommendationService.getFlightSegmentAirportCodeRoute(...args),
        getDepartureDateForSegment,
        getVeryFirstAirportCode,
        getVeryLastAirportCode,
        getStopAirportCodes,
    });

    function getVeryFirstAirportCode(route) {
        return route[0];
    }

    function getVeryLastAirportCode(route) {
        return route[route.length - 1];
    }

    function getStopAirportCodes(route) {
        return route.slice(1, -1);
    }

    function getDepartureDateForSegment(group) {
        const [firstFlight] = group.Flights;
        return firstFlight.DepartureDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-segment-service.js